export const ICON_BUTTON_SIZES = {
  small: '12',
  medium: '15',
  standard: '20',
  large: '25',
}
